export default __webpack_public_path__ + "static/media/DO.30fed772.svg";